import './style.css';

import React, { useState } from 'react';
import { t, useLocalization } from '../../l10n/l10n';
import { Button, Dialog } from '@economic/taco';
import { useCurrentAgreement, useCurrentUser } from '@economic/react-app';
import { Trans } from '@lingui/macro';
import ExternalLink from '../../ExternalLink';

export default function VismaConnectCongratsDialog() {
    const loadingTexts = useLocalization(textIds);
    const agreement = useCurrentAgreement();
    const user = useCurrentUser();
    const [show, setShow] = useState(true);

    if (loadingTexts || !show) {
        return null;
    }

    if (!user.vismaConnect.showCongratulationsPopup || agreement.showGettingStarted) {
        return null;
    }

    return (
        <Dialog open={show} size="xs">
            <Dialog.Content aria-label={t`CONNECT_CONGRATULATIONS_HEADLINE`}>
                <div className="vismaconnect-popups vismaconnect-congrats flex flex-col relative h-auto p-8">
                    <h1 className="text-center font-bold my-4 mx-auto">{t`CONNECT_CONGRATULATIONS_HEADLINE`}</h1>

                    <br />

                    <div>
                        <p>
                            <b>
                                <Trans>We hope you'll be happy with your new login</Trans>
                            </b>
                        </p>
                        <p>
                            <Trans>
                                Check out what your new login can do{' '}
                                <ExternalLink href="https://www.e-conomic.dk/sikkerhed/visma-connect">here</ExternalLink>
                            </Trans>
                        </p>
                    </div>

                    <br />

                    <p className="text-center">{t`CONNECT_CONGRATULATIONS_TEXTFIELD2`}</p>

                    <Button
                        className="bg-blue transition-all duration-200 ease-in align-middle rounded-sm border border-solid border-transparent text-white cursor-pointer block h-8 mt-8 mx-auto py-0 px-4 text-center"
                        appearance="primary"
                        type="button"
                        onClick={() => setShow(false)}>
                        {t`SHARED_CONFIRM_CLOSEWINDOW`}
                    </Button>
                </div>
            </Dialog.Content>
        </Dialog>
    );
}

const textIds = [
    'CONNECT_CONGRATULATIONS_HEADLINE',
    'CONNECT_CONGRATULATIONS_TEXTFIELD1',
    'CONNECT_CONGRATULATIONS_TEXTFIELD2',
    'SHARED_CONFIRM_CLOSEWINDOW',
];
